import React from "react";
import { ArticleContact } from "../../../../../amorg-common";
import { Button } from "../../../../../designSystem/button/Button";
import { AnimatedCollapsibleContent } from "../../../../../designSystem/collapsible/AnimatedCollapsibleContent";
import { colors } from "../../../../../designSystem/colors/color";
import { Flex, FlexItem } from "../../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../../designSystem/compositeComponents/ListRow";
import { Label } from "../../../../../designSystem/Label";

type ArticleViewContactsPanelProps = {
    contacts: ArticleContact[];
};
export function ArticleViewContactsPanel (props: ArticleViewContactsPanelProps): JSX.Element
{
    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <ListRow styleVariant='neutral' level='level2' stripColor={props.contacts.length === 0 ? colors.icon.passive : colors.icon.active}>
            <Flex alignItems='center'>
                <FlexItem flexGrow='1'>
                    {props.contacts.length === 0
                        ? <i>Ingen kontaktpersoner oprettet</i>
                        : <Label>Kontaktperson(er) ({props.contacts.length})</Label>
                    }
                </FlexItem>

                {props.contacts.length > 0 &&
                    <Button variant='text' icon={open ? 'caret_caretUp' : 'caret_caretDown'} onClick={() => setOpen(!open)} />
                }
            </Flex>

            <AnimatedCollapsibleContent open={open}>
                {props.contacts.map((contact) =>
                    <div key={contact.siteUserId}>
                        {contact.name} ({contact.email})
                    </div>
                )}
            </AnimatedCollapsibleContent>
        </ListRow>
    );
}